import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HealthUser } from "@app/core/models/health-user.state";
import { environment } from "@environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class UserSearchService {
  constructor(private http: HttpClient) {}

  searchUser(searchTerm: string): Observable<Array<HealthUser>> {
    return this.http.get<HealthUser[]>(`${environment.api.uri}/users`, {
      params: { searchTerm: searchTerm }
    });
  }
}
